module.exports = __webpack_public_path__ + "public/images/generated-multiplication.a702dd2590d94a8d2c3a6b2d6ff89a42.jpg";